import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { loadUsers } from "./actions";
import { User } from "services/user/types";

/**
 * Initial state.
 */
const initialState: User[] = [];

/**
 * Users slice.
 */
const usersSlice = createSlice({
  name: "users",
  initialState: initialState,
  reducers: {
    resetUsers(state) {
      state = initialState;
      
      return state;
    },
    deleteUsersByIds(state, action: PayloadAction<string[]>) {
      state = state.filter(value => value.userId && !action.payload.includes(value.userId));

      return state;
    },
    updateUser(state, action: PayloadAction<User>) {
      const index = state.findIndex((val) => val.userId === action.payload.userId);
      if (index) {
        state.splice(index, 1, action.payload);
      }

      return [...state];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadUsers.fulfilled, (state, action) => {
      if (action.payload.isSuccessful && action.payload.data) {
        return action.payload.data;
      }
    });
  },
});

export const { resetUsers, deleteUsersByIds, updateUser } = usersSlice.actions;

export default usersSlice.reducer;
